var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, Card, CardContent, Container, Typography, Chip, Grid, Divider, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, CircularProgress, } from '@mui/material';
import { NotificationsNoneOutlined, DescriptionOutlined, ArrowDropDown } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../routes/constants';
import { BoxContainerLayout } from '../../../components/BoxContainerLayout';
import { ServicoApi } from '../../../apis/servico-api';
import { TipoAtendimentoEnum } from '../../../model/enums/TipoAtendimentoEnum';
import { TipoRequerenteEnum } from '../../../model/enums/TipoRequerenteEnum';
import { TipoDocumentoEnum } from '../../../model/enums/TipoDocumentoEnum';
import { Requerimento } from '../../../model/Requerimento';
import { AuthConstants } from '../../../util/auth-constants';
import { LocalStorageUtils } from '../../../util/LocalStorageUtils';
import { Page } from '../../../apis/list-process-api';
import { NotificacaoApi } from '../../../apis/notificacao-api';
import { Notification } from '../../../components/Notification';
import { DateUtils } from '../../../util/DateUtils';
export var NotificacaoLista = function () {
    var navigate = useNavigate();
    var _a = useState([]), servicoDisponivel = _a[0], setServicoDisponivel = _a[1];
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    // Estados reais da API de Notificações
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(new Page()), notificacoes = _d[0], setNotificacoes = _d[1];
    var _e = useState({ severity: 'info', open: false, message: '' }), notification = _e[0], setNotification = _e[1];
    // Controle de modal para resposta
    var _f = useState(false), openModal = _f[0], setOpenModal = _f[1];
    var _g = useState(null), selectedNotif = _g[0], setSelectedNotif = _g[1];
    var _h = useState(''), respostaTexto = _h[0], setRespostaTexto = _h[1];
    var _j = useState(false), submittingResposta = _j[0], setSubmittingResposta = _j[1];
    // Controle de loading de cancelamento individual por id
    var _k = useState(null), submittingCancelar = _k[0], setSubmittingCancelar = _k[1];
    var carregarNotificacoes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, sortedContent, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, NotificacaoApi.pageable({ page: 0, size: 100, status: '', idRequerimento: '' })];
                case 2:
                    result = _a.sent();
                    if (result && result.content) {
                        sortedContent = __spreadArray([], result.content, true).sort(function (a, b) {
                            var dateA = a.dataCriacao ? new Date(a.dataCriacao).getTime() : 0;
                            var dateB = b.dataCriacao ? new Date(b.dataCriacao).getTime() : 0;
                            return dateB - dateA;
                        });
                        setNotificacoes(__assign(__assign({}, result), { content: sortedContent }));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error("Erro ao buscar notificações do backend:", error_1);
                    setNotification({
                        open: true,
                        message: 'Erro ao carregar notificações do servidor.',
                        severity: 'error',
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        ServicoApi.selectByMode(TipoAtendimentoEnum.ONLINE)
            .then(function (results) { return setServicoDisponivel(__spreadArray([], results, true)); })
            .catch(console.error);
        carregarNotificacoes();
    }, []);
    var handleMenuSolicitar = function (event) {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    var handleMenuCloseSolicitar = function () {
        setAnchorEl(null);
    };
    var handleNew = function (event, servico) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        LocalStorageUtils.removeEncryptedDataFromLocalStorage(AuthConstants.REQUERIMENTO_CACHE);
        handlePreparedNew(servico);
    };
    var handlePreparedNew = function (servico) {
        var temPf = servico.tipoRequerentePf === TipoRequerenteEnum.PESSOA_FISICA;
        var temPj = servico.tipoRequerentePj === TipoRequerenteEnum.PESSOA_JURIDICA;
        var _tipoDoc = temPj ? TipoDocumentoEnum.PJ : null;
        var tipoDoc = temPf ? TipoDocumentoEnum.PF : _tipoDoc;
        if (tipoDoc) {
            var _servico = __assign(__assign({}, servico), { tipoRequerente: [
                    servico.tipoRequerentePf,
                    servico.tipoRequerentePj,
                    servico.tipoRequerenteGov,
                ], tipoAtendimento: [
                    servico.tipoAtendimentoOnline,
                    servico.tipoAtendimentoPresencial,
                ] });
            var _newReq = __assign(__assign({}, new Requerimento()), { tipoRequerimentoDoc: tipoDoc, servico: __assign({}, _servico) });
            LocalStorageUtils.setEncryptedDataInLocalStorage(AuthConstants.REQUERIMENTO_CACHE, __assign({}, _newReq));
            navigate("".concat(Routes.REQUERIMENTO_CADASTRO.path));
        }
        else {
            alert('Este Serviço não suporta requerentes Pessoa Fisica ou Pessoa Jurídica.');
        }
    };
    var handleAbrirResposta = function (notif) {
        setSelectedNotif(notif);
        setRespostaTexto('');
        setOpenModal(true);
    };
    var handleEnviarResposta = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedNotif === null || selectedNotif === void 0 ? void 0 : selectedNotif.id) || !respostaTexto.trim())
                        return [2 /*return*/];
                    setSubmittingResposta(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, NotificacaoApi.responder(selectedNotif.id, respostaTexto)];
                case 2:
                    _a.sent();
                    setNotification({
                        open: true,
                        message: 'Resposta enviada com sucesso!',
                        severity: 'success',
                    });
                    setOpenModal(false);
                    carregarNotificacoes();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error("Erro ao responder notificação:", error_2);
                    setNotification({
                        open: true,
                        message: 'Erro ao enviar resposta ao backend.',
                        severity: 'error',
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setSubmittingResposta(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCancelarNotificacao = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id)
                        return [2 /*return*/];
                    setSubmittingCancelar(id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, NotificacaoApi.cancelar(id)];
                case 2:
                    _a.sent();
                    setNotification({
                        open: true,
                        message: 'Notificação cancelada com sucesso!',
                        severity: 'success',
                    });
                    carregarNotificacoes();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    console.error("Erro ao cancelar notificação:", error_3);
                    setNotification({
                        open: true,
                        message: 'Erro ao cancelar notificação no backend.',
                        severity: 'error',
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setSubmittingCancelar(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Calcula o número de pendências dinamicamente
    var pendingCount = useMemo(function () {
        return notificacoes.content.filter(function (n) { var _a; return ((_a = n.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'pendente'; }).length;
    }, [notificacoes.content]);
    return (_jsxs(BoxContainerLayout, { children: [_jsxs(Container, __assign({ maxWidth: "lg", sx: { mt: 4, mb: 4 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', gap: 2 } }, { children: [_jsx(Button, __assign({ variant: "text", startIcon: _jsx(DescriptionOutlined, {}), onClick: function () { return navigate(Routes.REQUERIMENTO_LISTAR.path); }, sx: { color: 'text.secondary', textTransform: 'none', fontSize: '1rem', fontWeight: 500 } }, { children: "Meus Requerimentos" })), _jsxs(Button, __assign({ variant: "text", startIcon: _jsx(NotificationsNoneOutlined, {}), sx: { color: 'text.primary', textTransform: 'none', fontSize: '1rem', fontWeight: 600, borderBottom: '2px solid', borderColor: 'primary.main', borderRadius: 0 } }, { children: ["Notifica\u00E7\u00F5es", pendingCount > 0 && (_jsx(Box, __assign({ component: "span", sx: {
                                                    ml: 1,
                                                    bgcolor: 'error.main',
                                                    color: 'white',
                                                    borderRadius: '12px',
                                                    px: 1,
                                                    py: 0.2,
                                                    fontSize: '0.75rem',
                                                    fontWeight: 'bold',
                                                } }, { children: pendingCount })))] }))] })), _jsxs(Box, { children: [_jsx(Button, __assign({ variant: "contained", color: "primary", endIcon: _jsx(ArrowDropDown, {}), sx: { fontWeight: 'bold' }, onClick: handleMenuSolicitar }, { children: "REQUERER NOVO SERVI\u00C7O" })), _jsxs(Menu, __assign({ onClose: handleMenuCloseSolicitar, open: Boolean(anchorEl), anchorEl: anchorEl }, { children: [servicoDisponivel.length > 0 &&
                                                (servicoDisponivel === null || servicoDisponivel === void 0 ? void 0 : servicoDisponivel.map(function (it, index) { return (_jsx(MenuItem, __assign({ onClick: function (e) { return handleNew(e, it); } }, { children: it.nomeReqServico }), "opt_cad_".concat(index.toString()))); })), servicoDisponivel.length === 0 && (_jsx(MenuItem, { children: "Nenhum Servi\u00E7o Dispon\u00EDvel no momento" }, 'no_options_disp'))] }))] })] })), _jsx(Divider, { sx: { mb: 3 } }), loading ? (_jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', mt: 4 } }, { children: _jsx(CircularProgress, {}) }))) : (_jsx(Grid, __assign({ container: true, spacing: 3 }, { children: notificacoes.content.length === 0 ? (_jsx(Typography, __assign({ align: "center", color: "textSecondary", sx: { mt: 4, width: '100%' } }, { children: "Nenhuma notifica\u00E7\u00E3o encontrada." }))) : (notificacoes.content.map(function (notif) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                            return (_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Card, __assign({ variant: "outlined", sx: {
                                        borderLeft: '4px solid',
                                        borderLeftColor: ((_a = notif.status) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'PENDENTE'
                                            ? '#ff9800'
                                            : (((_b = notif.status) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'CANCELADA' || ((_c = notif.status) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'CANCELADO')
                                                ? '#9e9e9e'
                                                : '#4caf50',
                                        boxShadow: '0px 2px 4px rgba(0,0,0,0.05)'
                                    } }, { children: _jsxs(CardContent, __assign({ sx: { p: 3 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2, gap: 2 } }, { children: [_jsxs(Box, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1, mb: 1 } }, { children: [((_d = notif.titulo) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes('vistoria')) ? (_jsx(NotificationsNoneOutlined, { color: "success", fontSize: "small" })) : ((_e = notif.titulo) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes('deferido')) || ((_f = notif.titulo) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes('autorização')) ? (_jsx(DescriptionOutlined, { color: "info", fontSize: "small" })) : (_jsx(DescriptionOutlined, { color: "warning", fontSize: "small" })), _jsx(Typography, __assign({ variant: "subtitle1", fontWeight: "bold" }, { children: notif.titulo })), _jsx(Chip, { label: ((_g = notif.status) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === 'PENDENTE'
                                                                            ? 'Pendente'
                                                                            : (((_h = notif.status) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === 'CANCELADA' || ((_j = notif.status) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === 'CANCELADO')
                                                                                ? 'Cancelada'
                                                                                : 'Respondida', size: "small", sx: {
                                                                            bgcolor: ((_k = notif.status) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === 'PENDENTE'
                                                                                ? '#fff3e0'
                                                                                : (((_l = notif.status) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === 'CANCELADA' || ((_m = notif.status) === null || _m === void 0 ? void 0 : _m.toUpperCase()) === 'CANCELADO')
                                                                                    ? '#eeeeee'
                                                                                    : '#e8f5e9',
                                                                            color: ((_o = notif.status) === null || _o === void 0 ? void 0 : _o.toUpperCase()) === 'PENDENTE'
                                                                                ? '#ef6c00'
                                                                                : (((_p = notif.status) === null || _p === void 0 ? void 0 : _p.toUpperCase()) === 'CANCELADA' || ((_q = notif.status) === null || _q === void 0 ? void 0 : _q.toUpperCase()) === 'CANCELADO')
                                                                                    ? '#616161'
                                                                                    : '#2e7d32',
                                                                            fontWeight: 'bold',
                                                                            ml: 1,
                                                                        } })] })), _jsx(Typography, __assign({ variant: "body2", color: "text.secondary", sx: { mb: 1.5 } }, { children: notif.conteudo })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 3 } }, { children: [_jsxs(Typography, __assign({ variant: "caption", color: "text.secondary" }, { children: [_jsx("strong", { children: "Processo:" }), " REQ-", notif.idRequerimento] })), _jsxs(Typography, __assign({ variant: "caption", color: "text.secondary" }, { children: [_jsx("strong", { children: "Setor:" }), " ", notif.nomeSetor] })), _jsxs(Typography, __assign({ variant: "caption", color: "text.secondary" }, { children: [_jsx("strong", { children: "Enviado em:" }), " ", notif.dataCriacao ? DateUtils.formatDateToBR(notif.dataCriacao) : ''] }))] }))] })), ((_r = notif.status) === null || _r === void 0 ? void 0 : _r.toUpperCase()) === 'PENDENTE' && (_jsx(Box, __assign({ sx: { display: 'flex', gap: 1, flexShrink: 0 } }, { children: _jsx(Button, __assign({ variant: "contained", color: "primary", startIcon: _jsx(DescriptionOutlined, {}), disabled: true, onClick: function () { return handleAbrirResposta(notif); }, sx: { textTransform: 'none' } }, { children: "Responder" })) })))] })), notif.resposta && (_jsxs(Box, __assign({ sx: { mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 } }, { children: [_jsx(Typography, __assign({ variant: "caption", color: "text.secondary", display: "block", sx: { mb: 0.5 } }, { children: "Sua resposta:" })), _jsx(Typography, __assign({ variant: "body2", color: "text.primary" }, { children: notif.resposta }))] })))] })) })) }), notif.id));
                        })) })))] })), _jsxs(Dialog, __assign({ open: openModal, onClose: function () { return !submittingResposta && setOpenModal(false); }, fullWidth: true, maxWidth: "sm" }, { children: [_jsx(DialogTitle, { children: "Responder Notifica\u00E7\u00E3o" }), _jsxs(DialogContent, { children: [_jsxs(DialogContentText, __assign({ sx: { mb: 2 } }, { children: [_jsx("strong", { children: "Tarefa:" }), " ", selectedNotif === null || selectedNotif === void 0 ? void 0 : selectedNotif.titulo] })), _jsx(TextField, { autoFocus: true, margin: "dense", label: "Sua Resposta", type: "text", fullWidth: true, multiline: true, rows: 4, variant: "outlined", value: respostaTexto, onChange: function (e) { return setRespostaTexto(e.target.value); }, disabled: submittingResposta })] }), _jsxs(DialogActions, __assign({ sx: { px: 3, pb: 3 } }, { children: [_jsx(Button, __assign({ onClick: function () { return setOpenModal(false); }, disabled: submittingResposta }, { children: "Voltar" })), _jsxs(Button, __assign({ onClick: handleEnviarResposta, variant: "contained", color: "primary", disabled: submittingResposta || !respostaTexto.trim() }, { children: [submittingResposta ? _jsx(CircularProgress, { size: 20, sx: { mr: 1 } }) : null, "Confirmar e Enviar"] }))] }))] })), _jsx(Notification, { props: notification, handleFormChange: setNotification })] }));
};
